import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { formatDate, getByType } from "@/utils/content";

export default function LatestNews() {
  const news = getByType("news");
  const [featured, ...rest] = news;
  const list = rest.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading
          eyebrow="News"
          title="最新资讯"
          desc="汇总《年轻的母亲3》的最新动态、官方消息与幕后故事，第一时间掌握剧集相关资讯。"
          actionTo="/category/news"
          actionLabel="查看全部资讯"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {featured && (
            <Link
              to={`/detail/${featured.id}`}
              className="group relative flex flex-col justify-end min-h-[320px] md:min-h-[420px] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - 年轻的母亲3`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
              <div className="relative z-10 p-5 md:p-7">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500 text-xs font-medium text-accent-950 mb-3">
                  <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-pushpin-2-line"></i></span>
                  头条
                </span>
                <h3 className="font-heading font-bold text-xl md:text-2xl text-white leading-snug group-hover:underline underline-offset-4">
                  {featured.title}
                </h3>
                <p className="mt-2.5 text-sm text-white/80 leading-relaxed line-clamp-2">{featured.summary}</p>
                <p className="mt-4 text-xs text-white/60">{formatDate(featured.date)}</p>
              </div>
            </Link>
          )}

          <ul className="flex flex-col divide-y divide-background-200 border-y border-background-200">
            {list.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/detail/${item.id}`}
                  className="group flex items-start gap-4 py-5 cursor-pointer"
                >
                  <div className="w-24 h-20 md:w-28 md:h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 年轻的母亲3`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading font-bold text-[15px] md:text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
                      {item.summary}
                    </p>
                    <p className="mt-2 text-xs text-foreground-400 flex items-center gap-1.5">
                      <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-calendar-line"></i></span>
                      {formatDate(item.date)}
                    </p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}